{
  "login": {
    "title": "Bienvenue sur Policy Vision",
    "subtitle": "Connectez-vous avec votre compte professionnel",
    "signInButton": "Se connecter avec Microsoft",
    "signingIn": "Connexion en cours...",
    "footer": "En vous connectant, vous acceptez nos Conditions d'utilisation et notre Politique de confidentialité"
  },
  "logout": {
    "button": "Déconnexion",
    "confirm": "Êtes-vous sûr de vouloir vous déconnecter ?"
  },
  "errors": {
    "loginFailed": "La connexion a échoué. Veuillez réessayer.",
    "unauthorized": "Vous n'êtes pas autorisé à accéder à cette ressource."
  }
}
